import AddMRNCont from '../../components/HSEQ/MRN/AddMRN/AddMRNCont'
import ControlledDocs from '../../components/HSEQ/ControlledDocuments/ControlledDocCont'
import MRNCont from '../../components/HSEQ/MRN/MRNCont'
import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import NoMatchComponent from '../../components/NoMatch'

export default function ClientRouter(props) {
  const url = props.match.url
  return (
    <Switch>
      <Route path={`${url}/mrn/:key/update`} component={AddMRNCont} />
      <Route path={`${url}/mrn/new`} component={AddMRNCont} />
      <Route path={`${url}/mrn`} component={MRNCont} />
      <Route path={`${url}/controlledDoc`} component={ControlledDocs} />
      <Route component={NoMatchComponent} />
    </Switch>
  )
}
